/* unplugin-vue-components disabled */import script from "./TopVav.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopVav.vue?vue&type=script&lang=ts&setup=true"

import "./TopVav.vue?vue&type=style&index=0&id=ff43ccbe&lang=scss&scoped=true"
import "./TopVav.vue?vue&type=style&index=1&id=ff43ccbe&lang=scss"

import exportComponent from "/Users/zouchanghua/Documents/project/xrverse/xrweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff43ccbe"]])

export default __exports__